// OilBrush.js
import { fabric } from "fabric";

export class OilBrush extends fabric.BaseBrush {
  constructor(canvas) {
    super();
    this.canvas = canvas;
    this.width = 25;
    this.color = "#000";
    this._points = [];
  }

  onMouseDown(pointer) {
    this._points = [pointer];
  }

  onMouseMove(pointer) {
    if (!this._points.length) return;
    this._points.push(pointer);
    this._render();
  }

  onMouseUp() {
    if (this._points.length < 2) return;

    const pathData = this._buildPath();
    const path = new fabric.Path(pathData, {
      stroke: this.color,
      strokeWidth: this.width,
      fill: null,
      strokeLineCap: "round",
      strokeLineJoin: "round",
      selectable: true,
      evented: true,
    });

    this.canvas.add(path);
    this.canvas.requestRenderAll();

    this._points = [];
  }

  _render() {
    const ctx = this.canvas.contextTop;
    this.canvas.clearContext(ctx);

    ctx.strokeStyle = this.color;
    ctx.lineWidth = this.width;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    // Add a streaky oil-like effect by layering multiple strokes
    for (let i = 1; i < this._points.length; i++) {
      const p1 = this._points[i - 1];
      const p2 = this._points[i];

      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();

      // Add texture: semi-transparent offset stroke
      ctx.globalAlpha = 0.3;
      ctx.lineWidth = this.width * 0.7;
      ctx.beginPath();
      ctx.moveTo(p1.x + 1.5, p1.y - 1.5);
      ctx.lineTo(p2.x + 1.5, p2.y - 1.5);
      ctx.stroke();
      ctx.globalAlpha = 1.0;
    }
  }

  _buildPath() {
    let d = "";
    for (let i = 0; i < this._points.length; i++) {
      const p = this._points[i];
      d += i === 0 ? `M ${p.x} ${p.y} ` : `L ${p.x} ${p.y} `;
    }
    return d;
  }
}
